"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _utils = require("../utils");

var _default = function _default(location) {
  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      params = _useState2[0],
      setParams = _useState2[1];

  (0, _react.useEffect)(function () {
    if (location !== null && location !== void 0 && location.search) {
      var _params = (0, _utils.paramsToObj)(location.search);

      setParams(Object.keys(_params).reduce(function (acc, key) {
        if (key.includes('utm')) acc.push([key, _params[key]]);
        return acc;
      }, []));
    } //eslint-disable-next-line

  }, []);
  return params;
};

exports["default"] = _default;